<template>
  <div class="panel-group">
    <div
      class="panel panel-default panel-toggle"
      v-for="gradeGoals in goalStaircase"
      :key="gradeGoals.grade"
      :class="{ active: isGradePanelHighlighted(gradeGoals.grade) }"
      v-show="gradeGoals.goals && gradeGoals.goals.length > 0">
      <div
        tabindex="0"
        role="button"
        @click="togglePanel(gradeGoals.grade, {registerAnalytics: true})"
        @keyup.enter="togglePanel(gradeGoals.grade, {registerAnalytics: true})"
        :aria-expanded="showPanel[gradeGoals.grade.replace('Grade ', '')] ? 'true' : 'false'"
      >
        <h3 class="panel-heading">Grade {{ gradeGoals.grade }}</h3>
      </div>
      <collapse v-model="showPanel[gradeGoals.grade]">
        <div class="panel-body">
          <div v-for="goal of sortedGoalsByScore(gradeGoals.goals)" :key="goal.uuid">
            <h4 @click="clickedStaircaseGoal(goal)">
              <router-link
                :to="{name: 'AnchorPage', params: {uuid: goal.uuid}}"
                v-if="goal.super_page">{{ goal.title }}</router-link>
              <router-link
                :to="{name: 'GoalContentPage', params: {slug: goal.slug}}"
                v-if="!goal.super_page">{{ goal.title }}</router-link>
            </h4>
            <p v-if="goal.super_page && showAnchorPageLabel">
              <AnchorPageLabel />&nbsp;
            </p>
            <wiki-text
              :text="firstLineOfText(goal.goal_text)"
              :plaintext="true"
              :locked="blurContentPermissions(goal).blur"/>
          </div>
        </div>
      </collapse>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WikiText from '@/components/WikiText'
import AnchorPageLabel from '@/components/goals/AnchorPageLabel'
import { CONTENT_TYPES, blurContentPermissions } from '@/util/access_visibility'

export default {
  name: 'Staircase',
  components: {
    WikiText,
    AnchorPageLabel
  },
  props: {
    goalStaircase: {
      type: Array,
      default() {
        return []
      }
    },
    grades: {
      type: Array,
      default() {
        return []
      }
    },
    pageUuid: {
      type: String,
      default: ''
    },
    accessPointLevel: {
      type: String,
      default: ''
    },
    accessPointGradeLevelUuid: {
      type: String,
      default: ''
    },
    showAnchorPageLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPanel: {}
    }
  },
  eventContext() {
    return {
      curr_uuid: this.pageUuid
    }
  },
  methods: {
    togglePanel(grade, options = {}) {
      this.$set(this.showPanel, grade, options.show || !this.showPanel[grade])
      Object.keys(this.showPanel).forEach(key => {
        if (key !== grade) {
          this.showPanel[key] = false
        }
      })

      if (options.registerAnalytics) {
        this.$sendEvent('Clicked Staircase Heading', {
          heading: grade
        })
      }
    },
    isGradePanelHighlighted(gradeOrGradeRangeLabel) {
      return (
        this.grades &&
        (this.grades.indexOf(gradeOrGradeRangeLabel) > -1 ||
          `${this.grades[0]}-${this.grades[this.grades.length - 1]}` === gradeOrGradeRangeLabel)
      )
    },
    expandInitialPanel() {
      let firstGradeInArr = this.grades[0]
      let gradeRangeStr = `${this.grades[0]}-${this.grades[this.grades.length - 1]}`
      let gradesInStaircase = this.goalStaircase.map(sc => sc.grade)
      if (gradesInStaircase.indexOf(firstGradeInArr) > -1) {
        this.togglePanel(firstGradeInArr, { show: true })
      } else if (gradesInStaircase.indexOf(gradeRangeStr) > -1) {
        this.togglePanel(gradeRangeStr, { show: true })
      }
    },
    firstLineOfText(text) {
      return text.split('\n')[0]
    },
    blurContentPermissions(goal) {
      return blurContentPermissions(
        this.isAnchorPage ? CONTENT_TYPES.SUPER_PAGE : CONTENT_TYPES.GOAL,
        goal,
        this.authInfo
      )
    },
    sortedGoalsByScore(goals) {
      let goalsCopy = [...goals]
      goalsCopy = goalsCopy.sort((g1, g2) => {
        return g2.score - g1.score
      })
      return goalsCopy
    },
    clickedStaircaseGoal(goal) {
      this.$sendEvent('Clicked Staircase Goal', {
        uuid: goal.uuid,
        title: goal.title
      })
    }
  },
  computed: {
    ...mapGetters('user', ['authInfo']),
    ...mapGetters('goaldetail', ['isAnchorPage'])
  },
  watch: {
    grades() {
      if (this.grades) {
        this.expandInitialPanel()
      }
    }
  },
  created() {
    if (this.grades) {
      this.expandInitialPanel()
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
.panel.panel-default {
  .panel-heading {
    background: transparent;
    color: @link-color;
    font-size: 14px;
    margin: 0px;
    &:hover {
      text-decoration: underline;
    }
  }
  &.active {
    .panel-heading {
      background: #f5f5f5;
    }
  }
}
.panel-body {
  border-top: 1px solid #ddd;
  h4 {
    margin-top: 18px;
    margin-bottom: 4px;

    &:first-of-type {
      margin-top: 10px;
    }
  }
  small {
    font-size: 75%;
  }
}
.label.label-power-standard {
  background: #154e9a;
  color: #f8e81c;
}
</style>
